import { Checkbox, IconButton, TableCell, TableRow } from '@mui/material'
import React from 'react'
import { destinationHeader } from './LuggageConstant'
import { useState } from 'react'
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import RemoveCircleRoundedIcon from '@mui/icons-material/RemoveCircleRounded';
import { navigation3 } from '../../../../common/helper';
const DestinationTableBody = ({ items, index, handleTableChecked, handleDestBranchChecked, sourceTableData, reportData }) => {
    const [isOpen, setIsOpen] = useState(false)
    return (
        <>
            <TableRow sx={{ backgroundColor: '#F5FAFE' }}>
                <TableCell>
                    {isOpen ?
                        <IconButton id={`DestIcons-${index}`} onClick={() => setIsOpen(false)} sx={{
                            padding: '0px !important',
                            color: '#0086FF !important'
                        }}
                            onKeyDown={(e) => {
                                navigation3(e, (reportData.length - 1) === index ? 'Select_Source_State' : `DestIcons-${index + 1}`, index === 0 ? 'searchContain' : `DestIcons-${index - 1}`, () => { })
                            }}
                        >
                            <RemoveCircleRoundedIcon />
                        </IconButton> :
                        <IconButton id={`DestIcons-${index}`} onClick={() => setIsOpen(true)}
                            sx={{
                                padding: '0px !important',
                                color: '#0086FF !important'
                            }}
                            onKeyDown={(e) => {
                                navigation3(e, (reportData.length - 1) === index ? 'Select_Source_State' : `DestIcons-${index + 1}`, index === 0 ? 'searchContain' : `DestIcons-${index - 1}`, () => { })
                            }}

                        >
                            <AddCircleRoundedIcon />
                        </IconButton>
                    }
                </TableCell>
                <TableCell sx={{ minHeight: '36px', fontSize: '12px', color: '#444', fontWeight: '500', fontStyle: 'italic' }} align={'left'}>{items?.Cityname}</TableCell>
                {destinationHeader.map((obj, i) => {
                    return (
                        !(["", "Cityname"].includes(obj.field)) ?
                            <TableCell key={`TCH-${i}`
                            } align='center'>
                                <Checkbox
                                    sx={{
                                        '&.Mui-disabled': {
                                            border: 'none !important',
                                            backgroundColor: 'transparent !important'
                                        },
                                        padding: 0,
                                        color: !items?.DestinationData?.every((val) => val[obj.field] === 1) && items[obj.field] == 1 ? '#0086ff' : '',
                                    }}
                                    inputProps={{
                                        'aria-label': 'Checkbox demo'
                                    }}
                                    id={`S${obj.field}-${index}`}
                                    checked={items[obj.field] == 1 && items?.DestinationData?.every((val) => val[obj.field] === 1)}
                                    disabled={sourceTableData.length > 0 ? sourceTableData[0][obj.field] === 0 : true}
                                    onChange={(e) => {
                                        handleTableChecked(e, index, obj.field)
                                    }}
                                />
                            </TableCell>
                            : null
                    )
                })}
            </TableRow>
            {isOpen && items?.DestinationData.map((val, branchIndex) => {
                return (
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell sx={{ minHeight: '36px', fontSize: '12px', color: '#444', fontWeight: '500' }} align={'left'}>{val?.Branchname}</TableCell>
                        {destinationHeader.map((obj, i) => {
                            return (
                                !(["", "Cityname"].includes(obj.field)) ?
                                    <TableCell key={`TCH-${i}`
                                    } align='center' >
                                        <Checkbox
                                            sx={{
                                                '&.Mui-disabled': {
                                                    border: 'none !important',
                                                    backgroundColor: 'transparent !important'
                                                },
                                                padding: 0,
                                            }}
                                            inputProps={{
                                                'aria-label': 'Checkbox demo'
                                            }}
                                            disabled={!items[obj.field] || (sourceTableData.length > 0 ? sourceTableData[0][obj.field] === 0 : true)}
                                            checked={val[obj.field] === 1}
                                            onChange={() => handleDestBranchChecked(val[obj.field], index, obj.field, branchIndex)}
                                        />
                                    </TableCell>
                                    : null
                            )
                        })}
                    </TableRow>
                )
            })}
        </>
    )
}

export default DestinationTableBody